import subscribeJson from './campaigns.subscribe.json';
import unsubscribeJson from './campaigns.unsubscribe.json';
import type {
  SubscribeCampaignConfig,
  SubscribeCampaignRegistry,
  UnsubscribeCampaignConfig,
  UnsubscribeCampaignRegistry,
} from './types';

export const subscribeCampaigns = subscribeJson as unknown as SubscribeCampaignRegistry;
export const unsubscribeCampaigns = unsubscribeJson as unknown as UnsubscribeCampaignRegistry;

/** Returns the config only if it exists AND is active — mirrors Symfony's `findActive(slug)`. */
export function getActiveSubscribeCampaign(slug: string): SubscribeCampaignConfig | undefined {
  const config = subscribeCampaigns[slug];
  return config && config.active ? config : undefined;
}

export function getActiveUnsubscribeCampaign(slug: string): UnsubscribeCampaignConfig | undefined {
  const config = unsubscribeCampaigns[slug];
  return config && config.active ? config : undefined;
}
